<template>
  <div>
    <breadcrumbs :back="back" :home="name">
      <template v-slot:left>
        <in-bond v-model="viewBond"/>
      </template>
    </breadcrumbs>

    <purtrak-table name="producttransactions" objectType="transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select
                   :listEndPoint="getListData" fields="" totalField="" v-model="selected"
                   :listFilters="listFilters" :sortBy.sync="sortBy"
                   @dblclick="transaction => viewTransaction(transaction)"
                   :title="name"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',
                                            activityTypes&&filters.activityType!=''?activityTypes.find(a=>a.value==filters.activityType).text:'',
                                            viewBond && filters.exciseType!='All'?exciseTypes.find(e=>e.value==filters.exciseType).text:'',
                                            lotTracking&&filters.lot?`Lot ${filters.lot}`:'']}"
                   :download-endpoint="exportListData">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.siteId=null;filters.activityType='';filters.exciseType='All';filters.lot='';filters.from=null;filters.to=null">
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item v-if="sites.length>1">
            <v-autocomplete label="Site" dense outlined :items="[{id:null,name:'All'},{divider:true},...sites]" v-model="filters.siteId" item-text="name" item-value="id"/>
          </v-list-item>
          <v-list-item v-if="activityTypes">
            <v-autocomplete label="Activity" dense outlined :items="activityTypes" v-model="filters.activityType"/>
          </v-list-item>
          <v-list-item v-if="viewBond">
            <v-autocomplete label="Excise" dense outlined class="text-body-2" :items="exciseTypes" v-model="filters.exciseType"/>
          </v-list-item>
          <v-list-item v-if="lotTracking">
            <filter-search label="Lot" v-model="filters.lot"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.siteId!=null" close small class="ml-1" @click:close="filters.siteId=null">{{siteName}}</v-chip>
          <v-chip v-if="activityTypes" v-show="filters.activityType!=''" close small class="ml-1" @click:close="filters.activityType=''">{{activityTypes.find(a=>a.value==filters.activityType).text}}</v-chip>
          <v-chip v-show="viewBond && filters.exciseType!='All'" close small class="ml-1 text-body-2" @click:close="filters.exciseType='All'">{{exciseTypes.find(e=>e.value==filters.exciseType).text}}</v-chip>
          <v-chip v-if="lotTracking" v-show="filters.lot" close small class="ml-1" @click:close="filters.lot=''">Lot {{filters.lot}}</v-chip>
        </template>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" @click="deleteMultiple=true;showDelete=true">Batch delete</v-btn>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.activityType="{item,printing}">
        {{item.description}}
        <div v-if="!printing" class="text-caption">{{item.comments}}</div>
      </template>
      <template v-slot:item.lot="{item,printing}">
        <template v-if="printing">{{item.lot}}</template>
        <v-hover v-else v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[...back,{text:name,to:{name:'InventoryProductsTransactions',params:{productId}}}]},query:{to:'reports/inventory/ReportsLot',id:item.refId,lot:item.lot,forward:0}})"
             :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.strength="{value}">
        {{value | number(2)}}%
      </template>
      <template v-slot:item.bottles="{value,printing}">
        <template v-if="printing">{{value | number(0)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(0)}}</span>
      </template>
      <template v-slot:item.cases="{value,printing}">
        <template v-if="printing">{{value | number(1)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(1)}}</span>
      </template>
      <template v-slot:item.sellingUnits="{value,printing}">
        <template v-if="printing">{{value | number(0)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(1)}}</span>
      </template>
      <template v-slot:item.pallets="{value,printing}">
        <template v-if="printing">{{value | number(1)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(1)}}</span>
      </template>
      <template v-slot:item.laa="{value,printing}">
        <template v-if="printing">{{value | number(3)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(3)}}</span>
      </template>
      <template v-slot:item.litres="{value,printing}">
        <template v-if="printing">{{value | number(3)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(3)}}</span>
      </template>
      <template v-slot:item.value="{value,printing}">
        <template v-if="printing">{{value | currency}}</template>
        <span :class="{'red--text':value<0}">{{value | currency}}</span>
      </template>
      <template v-slot:item.bottlesBalance="{value}">
        {{value | number(0)}}
      </template>
      <template v-slot:item.casesBalance="{value}">
        {{value | number(1)}}
      </template>
      <template v-slot:item.sellingUnitsBalance="{value}">
        {{value | number(0)}}
      </template>
      <template v-slot:item.palletsBalance="{value}">
        {{value | number(1)}}
      </template>
      <template v-slot:item.litresBalance="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:item.laaBalance="{value}">
        {{value | number(3)}}
      </template>
      <template v-slot:item.valueBalance="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="viewTransaction(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item v-if="lotTracking"
                        :to="{name:'ReportsView',params:{back:[...back,{text:name,to:{name:'InventoryProductsTransactions',params:{productId}}}]},query:{to:'reports/inventory/ReportsLot',id:item.refId,lot:item.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.refId}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=item;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='bottles'">
              {{totals.totalBottles | number(0)}}
            </td>
            <td class="text-right" v-else-if="header.value==='cases'">
              {{totals.totalCases | number(1)}}
            </td>
            <td class="text-right" v-else-if="header.value==='sellingUnits'">
              {{totals.totalSellingUnits | number(0)}}
            </td>
            <td class="text-right" v-else-if="header.value==='pallets'">
              {{totals.totalPallets | number(1)}}
            </td>
            <td class="text-right" v-else-if="header.value==='laa'">
              {{totals.totalLAA | number(3)}}
            </td>
            <td class="text-right" v-else-if="header.value==='litres'">
              {{totals.totalLitres | number(3)}}
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected transactions':'this transaction'" @delete="performDelete(transaction.refId, 'refId')"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import InBond from '@/components/InBond'
import excise from '@/plugins/excise'
import viewTransaction from '@/mixins/viewTransaction'

export default {
  name: 'InventoryProductsTransactions',
  mixins: [viewTransaction,performDelete],
  components: {InBond},
  props: {
    productId: {type:String, required:true}
  },
  data() {
    return {
      viewBond: localStorage.getItem('inBond') == '1' || localStorage.getItem('inBond') == null,
      filters: {
        from: null,
        to: null,
        siteId: null,
        activityType: '',
        exciseType: 'All',
        lot: ''
      },
      sortBy: '',
      name: '',
      dateDisplay: '',
      totals: {totalBottles:0, totalCases:0, totalSellingUnits:0, totalPallets:0, totalLAA:0, totalLitres:0, totalValue:0},
      activityTypes: [{text:'All',value:''},{divider:true},
                      {text:'Opening inventory',value:'ProductTransactionInitial'},
                      {text:'Bottling',value:'Bottling'},
                      {text:'Move to duty paid',value:'ProductTransactionMoveToDutyPaid'},
                      {text:'Reduce inventory',value:'ProductTransactionReduceInventory'},
                      {text:'Reassign lot',value:'ProductTransactionTransferLot'},
                      {text:'Transfer to site',value:'ProductTransactionTransferSite'},
                      {text:'Return to tank',value:'ProductTransactionReturnToTank'},
                      {text:'Shipment',value:'Shipment'},
                      {text:'Inventory receipt',value:'Receipt'}
                     ],
      transaction: {},
      showDelete: false,
      deleteMultiple: false,
      exciseTypes: excise.productExciseTypes(true),
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'siteName', visible:true},
                       { value: 'activityType', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'lot', visible:false},
                       { value: 'strength', visible:false},
                       { value: 'bottles', visible:true},
                       { value: 'sellingUnits', visible:false},
                       { value: 'cases', visible:false},
                       { value: 'pallets', visible:false},
                       { value: 'laa', visible:false},
                       { value: 'litres', visible:false},
                       { value: 'value', visible:false},
                       { value: 'bottlesBalance', visible:false},
                       { value: 'sellingUnitsBalance', visible:false},
                       { value: 'casesBalance', visible:false},
                       { value: 'palletsBalance', visible:false},
                       { value: 'laaBalance', visible:false},
                       { value: 'litresBalance', visible:false},
                       { value: 'valueBalance', visible:false}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'SITE', value: 'siteName', width:'15%',sortable:false, omit:() => this.sites.length <= 1},
                { text: 'ACTIVITY', value: 'activityType', width:'30%',sortable:false},
                { text: 'COMMENTS', value: 'comments', width:'30%',sortable:false},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true,
                    omit:() => !this.company.settings.lotTrackingForProducts || (!this.viewBond && !this.company.settings.lotTrackingForDutyPaid)},
                { text: 'STRENGTH', value: 'strength', width:'10%',align:'right',
                    omit:() => !this.company.settings.lotTrackingForProducts || (!this.viewBond && !this.company.settings.lotTrackingForDutyPaid)},
                { text: 'BOTTLES', value: 'bottles', width:'15%',sortable:true,align:'right'},
                { text: 'UNITS', value: 'sellingUnits', width:'15%',sortable:true,align:'right'},
                { text: 'CASES', value: 'cases', width:'15%',sortable:true,align:'right'},
                { text: 'PALLETS', value: 'pallets', width:'15%',sortable:true,align:'right'},
                { text: 'LAA', value: 'laa', width:'15%',sortable:true,align:'right'},
                { text: 'LITRES', value: 'litres', width:'15%',sortable:true,align:'right'},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right', omit:() => !this.values},
                { text: 'BOTTLES BAL', value: 'bottlesBalance', width:'15%',sortable:false,align:'right', omit:() => !this.showBalances},
                { text: 'UNITS BAL', value: 'sellingUnitsBalance', width:'15%',sortable:false,align:'right', omit:() => !this.showBalances},
                { text: 'CASES BAL', value: 'casesBalance', width:'15%',sortable:false,align:'right', omit:() => !this.showBalances},
                { text: 'PALLETS BAL', value: 'palletsBalance', width:'15%',sortable:false,align:'right', omit:() => !this.showBalances},
                { text: 'LAA BAL', value: 'laaBalance', width:'15%',sortable:false,align:'right', omit:() => !this.showBalances},
                { text: 'LITRES BAL', value: 'litresBalance', width:'15%',sortable:false,align:'right', omit:() => !this.showBalances},
                { text: 'VALUE BAL', value: 'valueBalance', width:'15%',sortable:false,align:'right', omit:() => !this.values || !this.showBalances}]
    }
  },
  computed: {
    showBalances() {
      return this.filters.activityType === '' /*&& this.filters.siteId == null*/ && this.filters.lot == '' && this.filters.exciseType === 'All' &&
             (this.sortBy === 'date' || this.sortBy === '');
    },
    back() {
      return [{text:'Products',to:{name:'InventoryProducts',query:{siteId:this.filters.siteId}}}];
    },
    sites() {
      return this.$store.getters.sites();
    },
    siteName() {
      return this.sites.find(site => site.id === this.filters.siteId)?.name;
    },
    company() {
      return this.$store.getters.company;
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    lotTracking() {
      return this.company.settings.lotTrackingForProducts && (this.viewBond || this.company.settings.lotTrackingForDutyPaid);
    },
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.siteId)
        filters.push({field:'siteId', comparator:'eq', value:this.filters.siteId});
      if (this.filters.activityType !== '')
        filters.push({field:'refType', comparator:'eq', value:this.filters.activityType});

      if (this.viewBond) {
        if (this.filters.exciseType === 'All')
          filters.push({field:'excise', comparator:'isNotNull', value:''});
        else
          filters.push({field:'excise', comparator:'eq', value:this.filters.exciseType});
      }
      else
        filters.push({field:'excise', comparator:'isNull', value:''});

      if (this.filters.lot)
        filters.push({field:'lot', comparator:'contains', value:this.filters.lot});

      return filters;
    }
  },
  methods: {
    async getListData(after, cursor, pageSize, filters, parameters, options) {
      const results = await this.$apiCall(`query InventoryProductsTransactions($id:ID!, $after: String, $first:Int, $before: String, $last: Int, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                             product(id:$id) {
                                                name
                                                transactions2(first:$first, after:$after, last:$last, before:$before, filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters) {
                                                  totalCount
                                                  totalBottles, totalSellingUnits, totalCases, totalPallets, totalLAA, totalLitres, totalValue
                                                  pageInfo {
                                                    hasPreviousPage
                                                    hasNextPage
                                                    startCursor
                                                    endCursor
                                                  }
                                                  edges {
                                                    cursor
                                                    node {
                                                      id,siteId,siteName,date,refType,refId,excise,description,refId,
                                                      bottles,cases,sellingUnits,pallets,litres,laa,value,comments,lot,strength
                                                      bottlesBalance,casesBalance,sellingUnitsBalance,palletsBalance,litresBalance,laaBalance,valueBalance
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                           {id:this.productId,
                                            after:after?cursor:null, first:after?pageSize:null,
                                            before:!after?cursor:null, last:!after?pageSize:null,
                                            filters, parameters,
                                            sortKey:options.sortBy[0], reverse:options.sortDesc[0]});

      this.name = `${results.data.product.name}: Transactions`;
      const transactions = results.data.product.transactions2;
      Object.assign(this.totals, {totalBottles:transactions.totalBottles, totalSellingUnits:transactions.totalSellingUnits, totalCases:transactions.totalCases,
                                  totalPallets:transactions.totalPallets, totalLAA:transactions.totalLAA, totalLitres:transactions.totalLitres, totalValue:transactions.totalValue});
      return transactions;
    },

    async exportListData(filters, parameters, options) {
      const results = await this.$apiCall(`query InventoryProductsTransactions($id:ID!, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                              product(id:$id) {
                                                transactionsExportCSV(filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters)
                                              }
                                            }`,
                                          {id:this.productId,
                                          filters, parameters,
                                           sortKey:options.sortBy[0], reverse:options.sortDesc[0]});
      if (!results.error)
        return results.data.product.transactionsExportCSV;
    }
  }
}
</script>